import Vue from 'vue';

export default (e) => {
  if (e && e.response && e.response.data) {
    // Se houver uma resposta com dados, use a mensagem de erro da resposta
    if (typeof e.response.data === 'string') {
      const errorMsg = e.response.data.replace('Error:', ''); // Remove "Error:"
      Vue.toasted.global.defaultError({ msg: errorMsg });
    } else if (e.response.data.error) {
      const errorMsg = e.response.data.error.replace('Error:', ''); // Remove "Error:"
      Vue.toasted.global.defaultError({ msg: errorMsg });
    } else {
      Vue.toasted.global.defaultError({
        msg: 'Preencha os dados corretamente',
      });
    }
  } else if (typeof e === 'string') {
    // Se `e` for uma string, use-a como mensagem de erro
    const errorMsg = e.replace('Error:', ''); // Remove "Error:"
    Vue.toasted.global.defaultError({ msg: errorMsg });
  } else {
    // Caso contrário, exiba uma mensagem de erro genérica
    Vue.toasted.global.defaultError();
  }
};
